import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import {
  IAssetClips, IClipList, IClipListCreate,
  IClipListQuery, IClipListUpdate,
} from './interfaces';

const basePath = '/clipList';

/* eslint-disable implicit-arrow-linebreak */

export const getClipList = (params: IClipListQuery): AxiosPromise<IApiResponse<IClipList[]>> => vaultApi.getInstance().get(basePath, { params });

export const updateClipList = (id: string, params: IClipListUpdate): AxiosPromise<IApiResponse<IClipList>> => vaultApi.getInstance().put(`${basePath}/${id}`, params);

export const createClipList = <T>(params: IClipListCreate): AxiosPromise<IApiResponse<IClipList>> => vaultApi.getInstance().post(basePath, params);

export const deleteClipList = <T>(id: string): AxiosPromise<any> => vaultApi.getInstance().delete(`${basePath}/${id}`);

export const getAssetClips = (assetId: string): AxiosPromise<IApiResponse<IAssetClips>> => vaultApi.getInstance().get(`${basePath}/assetClips/${assetId}`);
